export const UPLOAD_ITEM_STATUS = {
    START_UPLOAD: 'Start Upload',
    RESUME_UPLOAD: 'Resume',
    UPLOAD_QUEUED: 'Queued',
    UPLOAD_STARTED: 'Pending...',
    UPLOAD_UPLOADING: 'Uploading...',
    UPLOAD_PAUSED_ON_ERROR: 'Paused on error...',
    UPLOAD_CANCELED: 'Canceled',
    UPLOAD_ERROR: 'Error',
    UPLOAD_FINISHED: 'Uploaded',
    MAX_CHUNK_SIZE: 104857600, // 100MB
    DEFAULT_CHUNK_SIZE: 10485760, // 10MB
    RESUME_INTERVAL: 10000,
}
